import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";

export default function StepMedicalAndConvictions({
  data,
  update,
  medBox,
  convBox,
  onMedicalChange,
  onConvictionsChange,
}) {
  const {
    medical,
    medicalAbility,
    medicalNotes,
    conviction,
    convictionNotes,
  } = data;

  return (
    <Box component="section" className="nsp_step">
      <Typography variant="h6" sx={{ mt: 1 }}>
        Other
      </Typography>
      <Divider sx={{ mb: 2 }} />

      <Typography sx={{ mb: 1 }}>
        Please indicate any pre-existing medical or mental health conditions
        and any medication you are taking that may affect your ability to
        carry out your daily duties.{" "}
        <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>
          *
        </Box>
      </Typography>
      <RadioGroup
        name="medical"
        value={medical || ""}
        onChange={(e) => onMedicalChange(e.target.value)}
        sx={{ mb: 1 }}
      >
        <FormControlLabel
          value="no"
          control={<Radio />}
          label="No Medical or Mental Health Issues to disclose"
        />
        <FormControlLabel
          value="med"
          control={<Radio />}
          label="Yes, I have medical issues to disclose"
        />
        <FormControlLabel
          value="medMH"
          control={<Radio />}
          label="Yes, I have medical & mental health issues to disclose"
        />
        <FormControlLabel
          value="mh"
          control={<Radio />}
          label="Yes, I have mental health issues to disclose"
        />
      </RadioGroup>

      {medBox ? (
        <>
          <TextField
            label="Does your pre existing medical condition affect your ability to work"
            required
            multiline
            minRows={3}
            value={medicalAbility}
            onChange={(e) => update("medicalAbility", e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            label="Please provide the details of your medical and/or mental health issues"
            required
            multiline
            minRows={3}
            value={medicalNotes}
            onChange={(e) => update("medicalNotes", e.target.value)}
            sx={{ mb: 2 }}
          />
        </>
      ) : null}

      <Divider sx={{ my: 2 }} />
      <Typography sx={{ mb: 1 }}>
        You may be required to complete a Basic Disclosure Scotland check. Do
        you have any unspent convictions{" "}
        <Box component="span" sx={{ color: "error.main", fontWeight: 800 }}>
          *
        </Box>
      </Typography>
      <RadioGroup
        name="conviction"
        value={conviction || ""}
        onChange={(e) => onConvictionsChange(e.target.value)}
      >
        <FormControlLabel value="no" control={<Radio />} label="No" />
        <FormControlLabel value="yes" control={<Radio />} label="Yes" />
      </RadioGroup>

      {convBox ? (
        <TextField
          id="convictionNotes"
          label="Please give a brief description of any unspent convictions"
          multiline
          minRows={3}
          value={convictionNotes}
          inputProps={{ maxLength: 250 }}
          onChange={(e) => update("convictionNotes", e.target.value)}
          sx={{ mt: 2 }}
        />
      ) : null}
    </Box>
  );
}
